<div class="status" appEllipsisTooltip="">
  <span *ngIf="!withBorder" class="status__dot" [ngClass]="class"></span>
  <span *ngIf="withLabel && !withBorder" class="status__label">{{label | translate}}</span>
  <span *ngIf="withBorder" class="status__border" [ngClass]="class">{{label | translate}}</span>
</div>
